import OrderRepository from "@/repositories/vns/OrderRepository";
import makeState from "@/storages/Base/State";
import makeGetters from "@/storages/Base/Getters";
import makeMutations from "@/storages/Base/Mutations";

export default {
    name: 'order',
    namespaced: true,
    state: {
        ...makeState(),
        exams:[],
        recipient: {
            identifier: null,
            orders: [],
            reports: []
        }
    },
    getters: {
        ...makeGetters(),
        exams (state) {
            return state.exams
        },
        recipient (state) {
            return state.recipient
        }
    },
    mutations: {
        ...makeMutations(),
        setExams (state, array) {
            state.exams = array
        },
        setRecipient (state, obj) {
            state.recipient = obj
        }
    },
    actions: {
        setPagination ({ commit, state }, obj) {
            commit('setPagination', obj)
        },
        async listAll ({ commit, state }, params) {
            commit('setLoading', true)
            await OrderRepository.listOrder({...params, ...state.pagination}).then(response => {
                commit('setPagination', {
                    page: response.data.current_page,
                    per_page: response.data.per_page,
                    total: response.data.total
                })
                commit('setAll', response.data.data)
            }).catch(e => {})
            commit('setLoading', false)
        },
        setCurrent ({ commit, state }, obj) {
            commit('setCurrent', obj)
        },
        async listRecipient ({ commit, state }, params) {
            await OrderRepository.listRecipient({
                identifier: params.identifier
            }).then(response => {
                commit('setRecipient', response.data.data)
            })
        }
    }
}
